<template>
  <b-modal
    id="Wimdetail"
    size="lg"
    hide-footer
    centered
    content-class="wim-modal"
  >
    <!-- Header Section -->
    <template #modal-header="{ close }">
      <h5 class="modal-title">
        รายละเอียดข้อมูลรถบรรทุก
        <span class="station-name">
          ({{ details.station }})
        </span>
      </h5>
      <b-button
        variant="text"
        class="close-button"
        @click="close()"
      >
        <feather-icon
          icon="XIcon"
          size="18"
        />
      </b-button>
    </template>

    <!-- Body Section -->
    <b-container
      fluid
      class="p-2"
    >
      <!-- รูปภาพ Section -->
      <b-card class="mb-2 image-card">
        <b-row>
          <b-col
            md="6"
            class="mb-2"
          >
            <div class="image-wrapper">
              <b-img
                :src="plateImage"
                fluid
                class="modal-image"
                @click="showFullImage(plateImage)"
              />
              <div class="image-overlay">ภาพป้ายทะเบียน
              </div>
            </div>
          </b-col>
          <b-col
            md="6"
            class="mb-2"
          >
            <div class="image-wrapper">
              <b-img
                :src="truckImage"
                fluid
                class="modal-image"
                @click="showFullImage(truckImage)"
              />
              <div class="image-overlay">ภาพรถ
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <!-- ข้อมูลรถ Section -->
      <b-row>
        <b-col
          lg="6"
          class="mb-2"
        >
          <b-card
            no-body
            class="info-card"
          >
            <b-card-header class="d-flex align-items-center">
              <feather-icon
                icon="TruckIcon"
                size="16"
                class="mr-1"
              />
              <span>ข้อมูลรถ</span>
            </b-card-header>
            <b-card-body>
              <div class="detail-item">
                <span class="label">Ref No.</span>
                <span class="value">{{ details.refNo }}</span>
              </div>
              <div class="detail-item">
                <span class="label">ประเภทรถ</span>
                <span class="value d-flex align-items-center">{{ details.vehicleClass }}</span>
              </div>
              <div class="detail-item">
                <span class="label">จำนวนเพลา</span>
                <span class="value">{{ details.axles }}</span>
              </div>
              <div class="detail-item">
                <span class="label">ทะเบียน</span>
                <span class="value highlight">{{ details.plateNumber }}</span>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- ข้อมูลการเคลื่อนที่ Section -->
        <b-col
          lg="6"
          class="mb-2"
        >
          <b-card
            no-body
            class="info-card"
          >
            <b-card-header class="d-flex align-items-center">
              <feather-icon
                icon="ActivityIcon"
                size="16"
                class="mr-1"
              />
              <span>ข้อมูลการเคลื่อนที่</span>
            </b-card-header>
            <b-card-body>
              <div class="detail-item">
                <span class="label">เวลา</span>
                <span class="value">{{ details.dateTime }}</span>
              </div>
              <div class="detail-item">
                <span class="label">ช่องทางวิ่ง</span>
                <span class="value">{{ details.lane }}</span>
              </div>
              <div class="detail-item">
                <span class="label">ความเร็ว</span>
                <span class="value highlight">{{ details.speed }}</span>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- ข้อมูลน้ำหนัก Section -->
        <b-col
          lg="6"
          class="mb-2"
        >
          <b-card
            no-body
            class="info-card"
          >
            <b-card-header class="d-flex align-items-center">
              <feather-icon
                icon="ScaleIcon"
                size="16"
                class="mr-1"
              />
              <span>ข้อมูลน้ำหนัก</span>
            </b-card-header>
            <b-card-body>
              <div class="detail-item">
                <span class="label">น้ำหนักสูงสุดที่กฎหมายกำหนด</span>
                <span class="value">{{ details.maxGvw }}</span>
              </div>
              <div class="detail-item">
                <span class="label">น้ำหนักที่ชั่งได้</span>
                <span
                  class="value"
                  :class="{ 'text-danger': isOverWeight }"
                >{{ details.gvw }}</span>
              </div>
              <div
                v-if="isOverWeight"
                class="detail-item"
              >
                <span class="label">น้ำหนักเกิน</span>
                <span class="value text-danger">{{ details.overGvw }}</span>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <!-- สถานะ Section -->
        <b-col
          lg="6"
          class="mb-2"
        >
          <b-card
            no-body
            class="info-card"
          >
            <b-card-header class="d-flex align-items-center">
              <feather-icon
                icon="AlertCircleIcon"
                size="16"
                class="mr-1"
              />
              <span>สถานะ</span>
            </b-card-header>
            <b-card-body>
              <div class="detail-item">
                <span class="label">ผลการตรวจสอบ</span>
                <span class="value d-flex align-items-center">
                  <b-badge
                    pill
                    :variant="details.sortDecision === 'PASS' ? 'success' : 'danger'"
                    class="mr-2"
                  >
                    {{ details.sortDecision }}
                  </b-badge>
                  {{ details.status }}
                </span>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import {
  BModal,
  BRow,
  BCol,
  BImg,
  BBadge,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BContainer,
} from 'bootstrap-vue'

export default {
  name: 'WimDetailModal',

  components: {
    BModal,
    BRow,
    BCol,
    BImg,
    BBadge,
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BContainer,
  },

  data() {
    return {
      truckImage: '',
      plateImage: '',
      details: {
        refNo: '',
        station: '',
        seqNo: '',
        vehicleClass: '',
        classImage: '',
        axles: '',
        maxGvw: '',
        gvw: '',
        overGvw: '',
        dateTime: '',
        lane: '',
        speed: '',
        plateNumber: '',
        sortDecision: '',
        status: '',
      },
    }
  },

  computed: {
    isOverWeight() {
      return this.details.sortDecision === 'OVER'
    },
  },

  methods: {
    formatVehicleClass(value) {
      return value?.toString().padStart(3, '0') || '001'
    },

    sendInfo(item) {
      try {
        this.truckImage = item.Image01Name
        this.plateImage = item.Image02Name

        this.details = {
          refNo: `${item.StationID || ''}-${item.ENFID || ''}`,
          station: item.StationName || '',
          seqNo: item.TDID || '',
          vehicleClass: `${item.VehicleClassDesc2 || ''}: ${item.VehicleClassDesc3 || ''}`,
          axles: item.AxleCount || '-',
          lane: item.Lane || '-',
          speed: `${item.Speed || '-'} km/h`,
          maxGvw: `${item.LegalWeight || '-'} ตัน`,
          gvw: `${item.GrossWeight || '-'} ตัน`,
          overGvw: item.IsOverWeight === 'เกินพิกัด' ? `${item.GrossWeightOver || '-'} ตัน` : '-',
          dateTime: item.TimeStamp || '-',
          plateNumber: `${item.LPHeadNo || ''} ${item.ProvinceName || ''}`,
          sortDecision: item.IsOverWeight === 'เกินพิกัด' ? 'OVER' : 'PASS',
          status: item.IsOverWeight || '',
        }
      } catch (error) {
        console.error('Error setting modal data:', error)
        this.$bvToast.toast('ไม่สามารถแสดงข้อมูลได้', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })

        this.resetData()
      }
    },

    resetData() {
      this.truckImage = ''
      this.plateImage = ''
      this.details = {
        refNo: '',
        station: '',
        seqNo: '',
        vehicleClass: '',
        classImage: '',
        axles: '-',
        lane: '-',
        speed: '-',
        maxGvw: '-',
        gvw: '-',
        overGvw: '-',
        dateTime: '-',
        plateNumber: '',
        sortDecision: '',
        status: '',
      }
    },

    async showFullImage(imageUrl) {
      if (!imageUrl) return

      try {
        await this.$swal({
          imageUrl,
          imageAlt: 'Vehicle Image',
          width: 800,
          background: 'hsla(0, 100%, 100%, 0)',
          showCancelButton: false,
          showConfirmButton: false,
          showCloseButton: true,
        })
      } catch (error) {
        console.error('Error showing image:', error)
        this.$bvToast.toast('ไม่สามารถแสดงรูปภาพได้', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wim-modal {
  background: #1e3928;
  border-radius: 12px;

  ::v-deep .modal-header {
    background: linear-gradient(135deg, #2c3655 0%, #1e2339 100%);
    border-radius: 12px 12px 0 0;
    padding: 1rem;
    border-bottom: 1px solid rgba(255,255,255,0.1);

    .modal-title {
      color: #fff;
      font-size: 1.1rem;
      .station-name {
        font-size: 0.9em;
        opacity: 0.8;
        margin-left: 0.5rem;
      }
    }

    .close-button {
      color: white;
      opacity: 0.8;
      padding: 0;
      background: transparent;
      border: 0;
      transition: all 0.2s;
      &:hover {
        opacity: 1;
        transform: scale(1.1);
      }
    }
  }

  .image-card {
    background: #132217;
    border: 1px solid rgba(255,255,255,0.1);
    .image-wrapper {
      position: relative;
      border-radius: 8px;
      overflow: hidden;

      .modal-image {
        width: 100%;
        height: 200px;
        object-fit: cover;
        transition: transform 0.2s ease;
        cursor: pointer;

        &:hover {
          transform: scale(1.05);
        }
      }

      .image-overlay {
        position: absolute;
        bottom: 10px;
        left: 10px;
        background: rgba(0, 0, 0, 0.6);
        color: white;
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 0.9rem;
        backdrop-filter: blur(4px);
      }
    }
  }

  .info-card {
    background: #132217;
    border: 1px solid rgba(255,255,255,0.1);
    height: 100%;

    ::v-deep .card-header {
      background: rgba(255,255,255,0.05);
      border-bottom: 1px solid rgba(255,255,255,0.1);
      color: #fff;
      padding: 0.75rem 1rem;
      font-weight: 500;
    }

    ::v-deep .card-body {
      padding: 1rem;
    }

    .detail-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem 0;
      border-bottom: 1px dashed rgba(255,255,255,0.1);

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
      }

      .label {
        color: rgba(255,255,255,0.7);
        font-size: 0.9rem;
      }

      .value {
        color: #fff;
        font-weight: 500;

        &.highlight {
          color: #67f072;
        }

        &.text-danger {
          color: #ea5455;
        }
      }
    }
  }

  .vehicle-icon {
    filter: invert(1);
  }

  ::v-deep .badge-pill {
    padding: 0.4rem 1rem;
    font-weight: 500;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

// Media Queries
@media (max-width: 768px) {
  .wim-modal {
    .image-wrapper {
      .modal-image {
        height: 150px;
      }
    }

    .info-card {
      .detail-item {
        flex-direction: column;
        align-items: flex-start;

        .label {
          margin-bottom: 0.25rem;
        }

        .value {
          width: 100%;
        }
      }
    }
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
}
</style>
